import { render } from "./LoadingModal.vue?vue&type=template&id=998b3b58&scoped=true"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"

import "./LoadingModal.vue?vue&type=style&index=0&id=998b3b58&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998b3b58"]])

export default __exports__